module.exports = __webpack_public_path__ + "img/arrow-right-btn.c7cf423f.svg";